module.exports = __webpack_public_path__ + "img/chartIcon.c76dab79.png";